import { type ReactNode, useEffect } from 'react'

import { useInView } from 'react-intersection-observer'

import { Link } from '../../Link'
import { Wrapper } from './Wrapper'

type Props = {
	pageName: string
	level: number
	label: ReactNode
	fragment: string
	isActive: boolean
	setViewState: (inView: boolean) => void
}

export const Entry = ({ pageName, fragment, label, level, isActive, setViewState }: Props) => {
	const { ref } = useInView({
		root: document.getElementById('main'),
		fallbackInView: false,
		threshold: 1,
		rootMargin: '-30% 0px -50%',
		initialInView: window.location.hash === fragment,
		onChange: (inView) => setViewState(inView),
	})

	useEffect(() => {
		const linkedElement = document.getElementById(fragment)
		if (linkedElement) ref(linkedElement)
	}, [ref, fragment])

	return (
		<Wrapper level={level}>
			<Link isActive={isActive} name={pageName} fragment={fragment} replace>
				{label}
			</Link>
		</Wrapper>
	)
}
